import { render, staticRenderFns } from "./TabNews.vue?vue&type=template&id=42813f9b&scoped=true"
import script from "./TabNews.vue?vue&type=script&lang=js"
export * from "./TabNews.vue?vue&type=script&lang=js"
import style0 from "./TabNews.vue?vue&type=style&index=0&id=42813f9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42813f9b",
  null
  
)

export default component.exports